import { useEffect } from 'react';
import * as Analytics from '../Services/Analytics.service';

const ProductViewTracker = ({ product }) => {
  useEffect(() => {
    if (product?.item_id) {
      Analytics.trackViewItem(product);
    }
  }, [product]);

  return null;
};

export default ProductViewTracker;
